var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-bookmark"},[_c('button',{on:{"click":_vm.clickBookmark}},[_c('span',{staticClass:"icon",class:_vm.dynamicClass})])])}
var staticRenderFns = []

export { render, staticRenderFns }